import React from "react";
import _ from "lodash";

import DashboardTable from "../../../../../../../components/DashboardTable/DashboardTable";
import RiskScoreConfirmationModal from "../../../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/RiskScoreConfirmationModal/RiskScoreConfimrationModal";
import { RiskScoreConfirmationModalContext } from "../../../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/InvestmentRecommendationStep";

import usePaymentPlanEdit from "../hooks/usePaymentPlanEdit";
import { getSavingsPlansTableStructure } from "../table/columns";
import AddInstrumentDialog from "./AddInstrumentDialog";
import { getPaymentPlanMaxStartDate, TRANSACTION_TYPE_VALUES } from "../../../../../constants";
import { usePaymentPlanTableStyles } from "../../shared/paymentPlanTableStyles";
import EmptyTableMessage from "../../../../../../RiskProfiling/components/EmptyTableMessage";
import { useMPSummaryLine } from "../../shared/mpSummaryLine";

const SavingsPlanTable = ({
  portfolio,
  allInstruments,
  portfolioComponents,
  onInstrumentsChange,
  customerId,
  action,
  paymentPlanTransactionKey,
  groupInstruments,
  defaults,
  updateDefaults,
  dataService,
  isVirtual,
  isCustomerApp,
}) => {
  const classes = usePaymentPlanTableStyles();
  const clientSRI = dataService.srri;

  const {
    dialogOpen,
    setDialogOpen,
    instrumentsHandlers,
    isAnlageberatung,
    handleAmountChange,
    handleDiscountChange,
    handlePlanDataChange,
    handleAddItems,
    handleAddSavingPlanButtonClick,
    onRemoveClick,
    onRemoveAllClick,
    riskModalProps,
  } = usePaymentPlanEdit({
    portfolio,
    allInstruments,
    onInstrumentsChange,
    customerId,
    action,
    groupInstruments,
    defaults,
    updateDefaults,
    dataService,
    transactionType: TRANSACTION_TYPE_VALUES.SAVINGS_PLAN,
    isVirtual,
    clientSRI,
  });

  const tableStructure = getSavingsPlansTableStructure(
    action,
    portfolio.isModelportfolio,
    isVirtual
  );

  const { dataSource, expandSummaryLineChange, checkExpanded } = useMPSummaryLine(portfolio, groupInstruments || []);
  const selectPlanTitle = action === "create" ? undefined : "Sparplan auswählen";

  return (
    <RiskScoreConfirmationModalContext.Provider
      value={{
        ...riskModalProps,
        singleInvestmentEnabled: _.isEmpty(portfolio.transactions.savings_plan),
      }}
    >
      <div className={classes.tableContainer}>
        <DashboardTable
          tableLayout="auto"
          dataSource={dataSource}
          structure={tableStructure}
          tableClasses={classes}
          emptyDataMessage={<EmptyTableMessage isMPorPI={portfolio.isModelportfolio} />}
          withFooter
          expanded
          withInputs
          options={{
            isVirtual,
            expandSummaryLineChange,
            checkExpanded,
            paymentPlanTransactionKey,
            discountsDisabled: !_.get(portfolio, "ordering_discounts_allowed", []).includes("payment_plan"),
            availableDiscounts: portfolio.availableDiscounts,
            combinedDiscounts: portfolio.combinedDiscounts,
            depotDiscount: portfolio.discount,
            rotationOptions: portfolio.isModelportfolio
              ? portfolio.availableMPSavingsPlanPeriodicPlans
              : portfolio.availableSavingsPlanPeriodicPlans,
            fromDateOptions: portfolio.isModelportfolio
              ? portfolio.availableMPSavingsPlanExecutionDates
              : portfolio.availableSavingsPlanExecutionDates,
            handleDiscountChange,
            handlePlanDataChange,
            handleAmountChange,
            handleRemoveClick: onRemoveClick,
            onRemoveAllClick,
            isModelportfolio: portfolio.isModelportfolio,
            isAnlageberatung,
            clientSRRI: clientSRI,
            tillDateEnabled: portfolio.ordering_savings_plan_till_date_enabled,
            deleteDateEnabled: portfolio.ordering_savings_plan_delete_date_enabled,
            maxStartDate: (item) => getPaymentPlanMaxStartDate(item, portfolio, action),
            handleAddClick: () => handleAddSavingPlanButtonClick(action),
            addButtonText: selectPlanTitle,
          }}
        />
      </div>

      <AddInstrumentDialog
        open={dialogOpen}
        title={selectPlanTitle}
        onClose={() => setDialogOpen(false)}
        portfolio={portfolio}
        portfolioComponents={portfolioComponents}
        allInstruments={allInstruments}
        portfolioOnly={action !== 'create'}
        instrumentsHandler={instrumentsHandlers[action]}
        handleAddItems={handleAddItems}
        action={action}
        withSrri={isAnlageberatung}
        clientSRRI={clientSRI}
        customerId={customerId}
        isCustomerApp={isCustomerApp}
        isVirtual={isVirtual}
      />

      <RiskScoreConfirmationModal />
    </RiskScoreConfirmationModalContext.Provider>
  );
};

export default SavingsPlanTable;
